"use client"

import { hasDeleteAccess } from "../../../../../../Common/CheckAccess"

const DocumentPreviewModal = ({
  showModal,
  documents,
  currentIndex,
  onClose,
  onNavigate,
  onDeleteDocument,
  formatFileSize,
  permissions
}) => {
  if (!showModal || !documents || documents.length === 0) return null

  const currentDocument = documents[currentIndex]
  const hasMultipleDocuments = documents.length > 1

  const handlePrevious = () => {
    if (currentIndex > 0) {
      onNavigate(currentIndex - 1)
    }
  }

  const handleNext = () => {
    if (currentIndex < documents.length - 1) {
      onNavigate(currentIndex + 1)
    }
  }

  const handleDeleteDocument = () => {
    if (onDeleteDocument) {
      onDeleteDocument(currentDocument.procurementId, currentIndex)
    }
  }

  const renderDocumentPreview = (document) => {
    const isImage = document.fileType?.startsWith("image/") || document.url.match(/\.(jpg|jpeg|png|gif)$/i)
    const isPdf = document.fileType === "application/pdf" || document.url.toLowerCase().includes(".pdf")

    if (isPdf) {
      return (
        <div className="d-flex justify-content-center">
          <iframe
            src={document.url}
            width="100%"
            height="600px"
            title="PDF Preview"
            style={{ border: "1px solid #dee2e6", borderRadius: "0.375rem" }}
            onError={() => console.log("PDF load error")}
          />
        </div>
      )
    } else if (isImage) {
      return (
        <div className="text-center">
          <img
            src={document.url || "/placeholder.svg"}
            alt="Document Preview"
            className="img-fluid"
            style={{
              maxHeight: "600px",
              border: "1px solid #dee2e6",
              borderRadius: "0.375rem",
            }}
            crossOrigin="anonymous"
            onError={(e) => {
              e.target.src = "/placeholder.svg?height=400&width=600"
            }}
          />
        </div>
      )
    } else {
      return (
        <div className="alert alert-info text-center">
          <i className="bi bi-info-circle me-2"></i>
          Preview not available for this file type.
          <br />
          <a href={document.url} target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-3">
            <i className="bi bi-download me-2"></i>
            Download Document
          </a>
        </div>
      )
    }
  }

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title d-flex align-items-center">
              <i className="bi bi-file-earmark-text me-2"></i>
              Document Preview - {currentDocument.fileName}
              {hasMultipleDocuments && (
                <span className="badge bg-secondary ms-2">
                  {currentIndex + 1} of {documents.length}
                </span>
              )}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>

          {/* Document metadata */}
          <div className="modal-header border-bottom-0 pb-2">
            <div className="d-flex justify-content-between w-100 align-items-center">
              <div className="d-flex gap-3">
                <small className="text-muted">
                  <i className="bi bi-file-earmark me-1"></i>
                  {currentDocument.fileName}
                </small>
                {currentDocument.fileSize && (
                  <small className="text-muted">
                    <i className="bi bi-hdd me-1"></i>
                    {formatFileSize ? formatFileSize(currentDocument.fileSize) : "Unknown size"}
                  </small>
                )}
                {currentDocument.uploadDate && (
                  <small className="text-muted">
                    <i className="bi bi-calendar me-1"></i>
                    {new Date(currentDocument.uploadDate).toLocaleDateString()}
                  </small>
                )}
              </div>

              {/* {onDeleteDocument && hasDeleteAccess(permissions, "inventory") && (
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={handleDeleteDocument}
                  title="Delete Document"
                >
                  <i className="bi bi-trash"></i>
                </button>
              )} */}
            </div>
          </div>

          {/* Navigation for multiple documents */}
          {hasMultipleDocuments && (
            <div className="modal-header border-bottom-0 pb-0">
              <div className="d-flex justify-content-between w-100">
                <button className="btn btn-outline-secondary" onClick={handlePrevious} disabled={currentIndex === 0}>
                  <i className="bi bi-chevron-left"></i> Previous
                </button>

                <div className="d-flex gap-2 flex-wrap">
                  {documents.map((doc, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm ${index === currentIndex ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => onNavigate(index)}
                      title={doc.fileName}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>

                <button
                  className="btn btn-outline-secondary"
                  onClick={handleNext}
                  disabled={currentIndex === documents.length - 1}
                >
                  Next <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          )}

          <div className="modal-body">{renderDocumentPreview(currentDocument)}</div>

          <div className="modal-footer">
            <div className="d-flex justify-content-between w-100">
              <div className="d-flex gap-2">
                <a
                  href={currentDocument.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary"
                >
                  <i className="bi bi-box-arrow-up-right me-2"></i>
                  Open in New Tab
                </a>
                <a href={currentDocument.url} download={currentDocument.fileName} className="btn btn-outline-success">
                  <i className="bi bi-download me-2"></i>
                  Download
                </a>
              </div>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocumentPreviewModal
